module.exports = __webpack_public_path__ + "static/media/0_2019_11_01.9e793471.jpg";